import React, { useRef } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";

import Status from "../../models/domain/Status";
import HttpClient from "../../lib/HttpClient";
import Path from "../../models/ui/Path";
import TodaysAppointmentInfo from "../../models/domain/TodaysAppointmentInfo";

export default function CompleteAppointmentDialog(props: {
  appointmentInfo: TodaysAppointmentInfo;
  isOpen: boolean;
  closeFn: Function;
}) {
  const [open, setOpen] = React.useState(props.isOpen);
  const [cancelAppointment, confirmCancellation] = React.useState(false);

  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const previousValueRef = useRef(false);
  const previousValue = previousValueRef.current;
  if (props.isOpen !== previousValue && props.isOpen !== open) {
    setOpen(props.isOpen);
  }
  React.useEffect(() => {
    previousValueRef.current = props.isOpen;
  });

  React.useEffect(() => {
    const processCancellation = async () => {
      if (!cancelAppointment || !props.appointmentInfo.id) return;

      setLoading(true);
      setError(null);

      try {
        // First API call
        const paymentPath = new Path([
          "api",
          "v1",
          "appointments",
          props.appointmentInfo.id,
          "payment",
        ]).toString();

        const paymentRes = await HttpClient.performPut(paymentPath);
        const paymentBody = (paymentRes?.body as { status: Status })?.status;

        // Check for success and close dialog
        if (paymentBody.success) {
          confirmCancellation(false);
          props.closeFn(true);
        }
      } catch (err: any) {
        console.error(err);
        setError("Failed to complete appointment, contact admin.");
      } finally {
        setLoading(false);
      }
    };

    processCancellation();
  }, [cancelAppointment]);

  const currentState = () => {
    if (!cancelAppointment) return null;
    if (loading) return <span>Processing, please wait...</span>;
    if (error) return <span>{error}</span>;
    return null;
  };

  return (
    <Dialog
      open={open}
      onClose={() => confirmCancellation(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Complete appointment</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {props.appointmentInfo.patientName} - Are you sure you want to mark
          the payment as done?
          <br />
          {currentState()}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.closeFn(false)}>No</Button>
        <Button onClick={() => confirmCancellation(true)} autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
